import { commonGuard, adminGuard } from "../func"

const userRouter = {
  path: "user",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "user",
      beforeEnter: commonGuard,
      redirect: { name: "profile" },
      component: () => import("@/components/user/index.vue"),
      children: [
        {
          path: "profile",
          name: "profile",
          component: () => import("@/components/user/profile/index.vue"),
          beforeEnter: commonGuard,
        },

        {
          path: "managers",
          redirect: { name: "managers" },
          component: () => import("@/components/user/managers/index.vue"),
          children: [
            {
              path: "",
              name: "managers",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/user/managers/list.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "add",
              name: "add-manager",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/user/managers/add.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: ":userPk",
              name: "edit-manager",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/user/managers/edit.vue"),
              beforeEnter: commonGuard,
              props: true,
            },
            {
              path: "excel",
              name: "excel-add-manager-component",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/user/managers/excel.vue"),
              beforeEnter: commonGuard,
            },
          ],
        },

        {
          path: "department",
          redirect: { name: "user-department" },
          component: {
            template: "<router-view></router-view>",
          },
          beforeEnter: adminGuard,
          children: [
            {
              path: "",
              name: "user-department",
              meta: { auth: ["Manager"] },
              component: () => import("@/components/user/department/index.vue"),
              beforeEnter: adminGuard,
            },
            {
              path: ":id",
              name: "user-edit-department",
              meta: { auth: ["Manager"] },
              component: () => import("@/components/user/department/edit.vue"),
              beforeEnter: adminGuard,
            },
          ],
        },

        {
          path: "approver",
          redirect: { name: "approver" },
          component: {
            template: "<router-view></router-view>",
          },
          beforeEnter: adminGuard,
          children: [
            {
              path: "",
              name: "approver",
              component: () => import("@/components/user/approver/index.vue"),
              beforeEnter: adminGuard,
            },
          ],
        },
      ],
    },
  ],
}

export default userRouter
